import React, { useMemo, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import EphemeList from '../../Component/EphemeList'
import Filters from '../../Component/Filters/Filters'
import GenderFilter from '../../Component/Filters/GenderFilter'
import MemberList from '../../Component/MemberList'
import Tabs from '../../Component/Tabs/Tabs'
import { PLATFORM } from '../../Hook/platform'
import Content from '../Content'
import Footer from '../Footer'
import Header from '../Header'
import Main from '../Main'
import MenuMobile from '../MenuMobile'
import LocationSelect from './LocationSelect'
let allCountries:any[]|null = null;
function Top() {
  const [gender, setGender] = useState("woman")
  let allContinents = Object.keys(PLATFORM.continent);
  allCountries = allContinents.map(e => PLATFORM.continent[e].map(e => e.id)).flat();
  const [topSearch, setTopSearch] = useState({ countries: allCountries! });

  const update = (continent: string, country: number) => {
    if (continent === "all") {
      return setTopSearch({ countries: allCountries! });
    }
    if (country === -1) {
      if (PLATFORM.continent[continent].map(e => e.id)[0] !== topSearch.countries[0])
        setTopSearch({ countries: PLATFORM.continent[continent].map(e => e.id) });
    } else {
      setTopSearch({ countries: [country as any] });
    }
  }

  return (

    <>
      <Header />
      <Content>
        <Main>
          <div className=' max-w-5xl w-full m-auto my-0 flex flex-col gap-8 px-2'>
            <div className="flex flex-col gap-6">
              <div className='text-center [&>*]:text-primary text-2xl'><FormattedMessage id="topandprogress__page_title" /></div>
              <div className=' max-w-5xl w-full m-auto my-0 flex lg:flex-row flex-col gap-8 items-center'>
                <GenderFilter hasAngel localUpdater={setGender} currentValue={gender} />
                <LocationSelect update={update} />
              </div>
              <MemberList
                noGlobalFilters
                endpoint='top'
                additionalInputs={{
                  top: gender,
                  ...topSearch
                }}

              />
            </div>

            <div>
              <div className='text-center mb-6 [&>*]:text-primary text-2xl'><FormattedMessage id="top_progress__title" /></div>
              <MemberList
                noGlobalFilters
                progress
                endpoint='top_flames_day'
                additionalInputs={{
                  top: gender,
                }}
              />
            </div>


          </div>
        </Main>
      </Content>
      <Footer />
      <MenuMobile />
    </>
  )
}

export default Top